import { IconVariant, MolsonButton, MolsonIcon } from '@components/reusable'
import {
  type ButtonProps,
  type SxProps,
  type Theme,
  useTheme
} from '@mui/material'

import type { ReactNode } from 'react'

export type MolsonShowMoreButtonProps = ButtonProps & {
  children: ReactNode
  iconVariant?: IconVariant
  sx?: SxProps<Theme>
  dataTestId?: string
}

export const MolsonShowMoreButton = ({
  children,
  iconVariant = 'PLUS',
  sx,
  ...props
}: MolsonShowMoreButtonProps) => {
  const theme = useTheme()

  return (
    <MolsonButton
      {...props}
      sx={{
        height: '24px',
        minWidth: '60px !important',
        padding: '6px',
        background: theme.palette.primary.lightest,
        borderColor: theme.palette.primary.lightest,
        color: theme.palette.secondary[700],
        borderRadius: '4px',
        fontSize: '12px',
        ...sx
      }}
      startIcon={
        <MolsonIcon
          variant={iconVariant}
          customWidth="10px"
          customHeight="10px"
        />
      }
    >
      {children}
    </MolsonButton>
  )
}
